import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Toolbar from "@mui/material/Toolbar";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import { BsFullscreen } from "react-icons/bs";
import { BsArrowsFullscreen } from "react-icons/bs";
import MaterialBox from "../../../../components/MaterialBox";
import {
  setMiniSidenav,
  setTransparentNavbar,
  useMaterialUIController,
} from "../../../../context";
import { navbarContainer, navbar, navbarRow } from "./styles";
import Breadcrumbs from "./components/Breadcrumbs";
import NotificationItem from "./components/NotificationItem";
import MaterialAvatar from "../../../../components/MaterialAvatar";
import { Avatar, Button } from "@mui/material";
import stringAvatar from "../../../../functions/stringAvatar";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import LogoutIcon from "@mui/icons-material/Logout";
import UserDetailsContext from "../../../../context/auth";
import MaterialButton from "../../../../components/MaterialButton";
import { Check, Close } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
function DashboardNavbar({ absolute, light, isMini, isCheckedIn, onClick }) {
  const { user } = useContext(UserDetailsContext);
  const theme = useTheme();
  const [navbarType, setNavbarType] = useState();

  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator } =
    controller;
  const [openMenu, setOpenMenu] = useState(false);
  const route = useLocation().pathname.split("/").slice(1);

  let val = useLocation();

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [userDetails, setUserDetails] = useState({
    name: "",
    picture: "",
    email: "",
  });
  const [pageState, setPageState] = useState({
    state: "init",
  });
  useEffect(() => {
    const getUser = () => {
      const userDetails = sessionStorage.getItem("user");
      const getDetails = JSON.parse(userDetails);

      setUserDetails({
        name: user[0]?.first_name || getDetails.first_name || "Admin",
        email: user?.email || getDetails.email || "",
        picture: user?.picture || getDetails.picture || "",
      });
      setPageState({
        state: "default",
      });
    };
    getUser();
  }, []);

  const signOut = () => {
    navigate("/");
  };

  const toggleFullScreen = () => {
    if (
      !document.fullscreenElement && // Check if the page is not in fullscreen
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      // Enter Fullscreen for modern browsers
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        // Firefox
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        // Chrome, Safari, Opera
        document.documentElement.webkitRequestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        // IE/Edge
        document.documentElement.msRequestFullscreen();
      }
    } else {
      // Exit Fullscreen
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        // Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        // Chrome, Safari, Opera
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        // IE/Edge
        document.msExitFullscreen();
      }
    }
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Logout ?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        signOut();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setOpenMenu(false);
      },
    });
  };

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(
        dispatch,
        (fixedNavbar && window.scrollY === 0) || !fixedNavbar
      );
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);
  const navigate = useNavigate();
  const open = Boolean(openMenu);
  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem
        icon={
          <>
            {userDetails.picture ? (
              <Avatar
                alt={userDetails.name}
                src={userDetails.picture}
                sx={{ width: 24, height: 24 }}
              />
            ) : (
              <MaterialAvatar
                size="sm"
                {...stringAvatar(
                  userDetails.name || userDetails.email || "UNNAMED"
                )}
              />
            )}
          </>
        }
        title={userDetails.name || userDetails.email}
      />
      <NotificationItem
        id="logout"
        onClick={AddDelete}
        icon={<LogoutIcon />}
        title={"Logout"}
      />
    </Menu>
  );

  return (
    // <></>
    // <AppBar
    //   // position={absolute ? "absolute" : navbarType}
    //   // position="navbarType"
    //     position="static"
    //   color="inherit"

    //   sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
    // >
    //   <Toolbar sx={(theme) => navbarContainer(theme)}>
    //     {
    //       pageState.state === 'default' && (
    //         <>
    //           <MaterialBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}  >
    //             <MaterialBox display="flex" >
    //               <Icon fontSize="medium" onClick={handleMiniSidenav} sx={{ cursor: "pointer" }}>
    //                 {miniSidenav ? <MenuOpenIcon /> : <MenuIcon />}
    //               </Icon>
    //               <MaterialBox ml={1}>
    //                 <Breadcrumbs icon={<HomeIcon />} title={route[route.length - 1]} route={route} light={light} />
    //               </MaterialBox>
    //             </MaterialBox>
    //           </MaterialBox>
    //           {isMini ? null : (
    //             <MaterialBox sx={(theme) => navbarRow(theme, { isMini })}>
    //               {/* <MaterialButton
    //                 variant="outlined"
    //                 color={isCheckedIn ? 'error' : 'success'}
    //                 onClick={onClick}
    //                 // size='small'
    //                 style=
    //                 {{
    //                   maxWidth: '5px',
    //                   minWidth: '5px',
    //                 }}
    //               >
    //                 {isCheckedIn ? <Close /> : <Check />}
    //               </MaterialButton> */}
    //               <IconButton
    //                 onClick={handleOpenMenu}
    //                 size="small"
    //                 aria-controls={open ? 'account-menu' : undefined}
    //                 aria-haspopup="true"
    //                 aria-expanded={open ? 'true' : undefined}
    //               >
    //                 <MaterialAvatar alt={userDetails.name} src={userDetails.picture} sx={{ width: 35, height: 35 }} />
    //               </IconButton>
    //               {renderMenu()}
    //             </MaterialBox>
    //           )}
    //         </>
    //       )
    //     }
    //   </Toolbar>
    // </AppBar>
    <AppBar
      position={absolute ? "absolute" : navbarType}
      // position="navbarType"

      color="inherit"
      sx={(theme) => ({
        ...navbar(theme, { transparentNavbar, absolute, light }),
     
        boxShadow: theme.palette.mode === "dark" ? 0 : 3, // Optional: Add shadow for non-dark mode
        transition: "all 0.3s ease", // Smooth transition for dynamic state changes
      })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        {pageState.state === "default" && (
          <>
            {/* Left Section: Menu Toggle & Breadcrumb */}
            <MaterialBox
              color="inherit"
              mb={{ xs: 1, md: 0 }}
              sx={(theme) => navbarRow(theme, { isMini })}
            >
              <MaterialBox display="flex" alignItems="center">
                {/* Menu Toggle Icon */}
                <Icon
                  fontSize="medium"
                  onClick={handleMiniSidenav}
                  sx={{ cursor: "pointer", marginRight: 2 }}
                >
                  {miniSidenav ? <MenuOpenIcon /> : <MenuIcon />}
                </Icon>

                {/* Breadcrumb Navigation */}
                <MaterialBox ml={1}>
                  <Breadcrumbs
                    icon={<HomeIcon />}
                    title={route[route.length - 1]}
                    route={route}
                    light={light}
                    sx={{ color: theme.palette.text.primary }} // Optional: Adjust breadcrumb text color
                  />
                </MaterialBox>
              </MaterialBox>
            </MaterialBox>

            {/* Right Section: Profile Menu */}
            {isMini ? null : (
              <MaterialBox
                sx={{ display: "flex", alignItems: "center", gap: 2 }}
              >
                {/* Fullscreen Button */}
                <IconButton
                  onClick={toggleFullScreen}
                  sx={{
                    padding: 0.5, // Reduce padding for a smaller button
                    fontSize: 20, // Adjust overall button size
                  }}
                >
                  <BsArrowsFullscreen style={{ fontSize: 20 }} />{" "}
                  {/* Adjust icon size */}
                </IconButton>

                {/* Profile Icon with Menu */}
                <MaterialBox sx={(theme) => navbarRow(theme, { isMini })}>
                  <IconButton
                    onClick={handleOpenMenu}
                    size="small"
                    aria-controls={open ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    sx={{
                      borderRadius: "50%",
                      padding: 0,
                      "&:hover": {
                        backgroundColor: (theme) => theme.palette.action.hover,
                      },
                    }}
                  >
                    <MaterialAvatar
                      alt={userDetails.name}
                      src={userDetails.picture}
                      sx={{ width: 35, height: 35 }}
                    />
                  </IconButton>

                  {/* Profile Menu */}
                  {renderMenu()}
                </MaterialBox>
              </MaterialBox>
            )}
          </>
        )}
      </Toolbar>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
    </AppBar>
  );
}

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
  isCheckedIn: PropTypes.bool,
  onClick: PropTypes.func,
};

export default DashboardNavbar;
